import React, { useMemo } from 'react';
import { IOption } from '../IOption';
import { typesToOptions } from '../utils/typesToOptions';
import { IFormProps } from './common/IFormProps';
import { FormAutocompleteField } from './FormAutocompleteField';

interface IProps<TModel, TType extends string> extends IFormProps<TModel> {
	record: Record<TType, string>;
	withNone?: boolean;
}

export const FormAutocompleteFieldFromTypes = <TModel extends unknown, TType extends string>({ record, ...props }: IProps<TModel, TType>) => {
	const sorted = useMemo(() => typesToOptions(Object.keys(record) as TType[], record), [record]);

	return (
		<FormAutocompleteField<TModel, IOption<TType>>
			options={sorted}
			{...props}
		/>
	);
};
